


















































import { Consent } from "@/api/open-api";
import { QTable } from "quasar";
import Vue from "vue";
export default Vue.extend({
  name: "c-radio-filter",
  props: ["responseDescription", "value", "responseList"]
});
